<template>
    <div>
    <footer class="main-footer div-home">
        <div class="back-to-top">
            <a href="#">

                <div>
                    بازگشت به
                    بالا
                </div>
                <span class="icon"><i class="now-ui-icons arrows-1_minimal-up"></i></span>
            </a>
        </div>
        <div class="container">
            <!--<footer-services></footer-services>-->
            <!--<footer-widgets></footer-widgets>-->
            <footer-info></footer-info>
        </div>
        <footer-description></footer-description>
        <footer-copyright></footer-copyright>
       
    </footer>
   </div>
</template>

<script>
    import footerCopyright from './footerCopyright.vue'
    import footerDescription from './footerDescription.vue'
    import footerInfo from './footerInfo.vue'
 
    export default {
        data() {
            return {
                isUserLogined: false
            }
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
        components: {
            'footer-copyright': footerCopyright,
            'footer-description': footerDescription,
            'footer-info': footerInfo,
             
        }
    }
</script>

<style scoped>
 
     

     
</style>